import { render } from "./InventoryItemCardItem.vue?vue&type=template&id=b1166bce&scoped=true"
import script from "./InventoryItemCardItem.vue?vue&type=script&lang=js"
export * from "./InventoryItemCardItem.vue?vue&type=script&lang=js"

import "./InventoryItemCardItem.vue?vue&type=style&index=0&id=b1166bce&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1166bce"]])

export default __exports__